module.exports = __webpack_public_path__ + "static/media/PR1.b3f35951.jpg";